import { faCheck, faClose, faExclamation, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import ptBR from "date-fns/locale/pt-BR";
import { format, parse } from "date-fns";

const StatusParecerAnalise = ({ value }) => {
    switch (value) {
        case 0:
            return (
                <Tooltip title="Não avaliado" placement="right">
                    <div className="status_texto">
                        <div className="status_digitacao">
                            <FontAwesomeIcon icon={faRefresh} />
                        </div>
                        Não avaliado
                    </div>
                </Tooltip>
            )
        case 1:
            return (
                <Tooltip title="Favorável" placement="right">
                    <div className="status_texto">
                        <div className="status_homologado">
                            <FontAwesomeIcon icon={faCheck} />
                        </div>
                        Favorável
                    </div>
                </Tooltip>
                
            )
        case 2:
            return (
                <Tooltip title="Favorável com ressalvas" placement="right">
                    <div className="status_texto">
                        <div className="status_aguardando">
                            <FontAwesomeIcon icon={faExclamation} />
                        </div>
                        Favorável com ressalvas
                    </div>
                </Tooltip>
            )
        default:
            return (
                <Tooltip title="Reprovado" placement="right">
                    <div className="status_texto">
                        <div className="status_cancelado ">
                            <FontAwesomeIcon icon={faClose} />
                        </div>
                        Reprovado
                    </div>
                </Tooltip>
            )
    }
}

const verificaSituacaoDaAnalise = (params, value) => {
    switch (params.field) {
        case 'ParecerRepresentante':
            if (params?.row?.ParecerRepresentante !== 0 && value !== 0) {
                return <StatusParecerAnalise value={value} />;
            } else {
                return getStatusIconDefault(value);
            }
        case 'ParecerProjeto':
            if (params?.row?.ParecerProjeto !== 0 && value !== 0) {
                return <StatusParecerAnalise value={value} />;
            } else {
                return getStatusIconDefault(value);
            }
        case 'ParecerDocumentos':
            if (params?.row?.ParecerDocumentos !== 0 && value !== 0) {
                return <StatusParecerAnalise value={value} />;
            } else {
                return getStatusIconDefault(value);
            }
        case 'ParecerInstalacao':
            if (params?.row?.ParecerInstalacao !== 0 && value !== 0) {
                return <StatusParecerAnalise value={value} />;
            } else {
                return getStatusIconDefault(value);
            }
        default:
            return getStatusIconDefault(value);
    }

    function getStatusIconDefault(value) {
        return (
            <Tooltip title="Não avaliado" placement="right">
                <div className="status_texto">
                    <div className="status_digitacao">
                        <FontAwesomeIcon icon={faRefresh} />
                    </div>
                    Não avaliado
                </div>
            </Tooltip>
        );
    }
};

const columnsAnaliseSolicitacaoCompartilhamentoAnalise = [
    {
        field: 'DataApresentacao', headerName: 'Data de apresentação', width: 200,
        renderCell: (params) => {
            let dataFormatada = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            })

            return dataFormatada;
        }
    },
    { field: 'PrazoAnalise', headerName: 'Data de análise', width: 200,
        renderCell: (params) => {
            let dataFormatada = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            })

            return dataFormatada;
        } 
    },
    {
        field: 'DataParecerRepresentante', headerName: 'Data de parecer representante', width: 200,
        renderCell: (params) => {
            let dataFormatada = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            })

            return dataFormatada;
        }
    },
    {
        field: 'ParecerRepresentante',
        headerName: 'Parecer representante',
        renderCell: (params) => {
            return verificaSituacaoDaAnalise(params, params.value);
        },
        flex: 1,
    },
    {
        field: 'DataParecerProjeto', headerName: 'Data de parecer projeto', width: 200,
        renderCell: (params) => {
            let dataFormatada = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            })

            return dataFormatada;
        }
    },
    {
        field: 'ParecerProjeto',
        headerName: 'Parecer dos pontos',
        renderCell: (params) => {
            return verificaSituacaoDaAnalise(params, params.value);
        },
        flex: 1,
    },
    {
        field: 'DataParecerDocumentos', headerName: 'Data de parecer documentos', width: 200,
        renderCell: (params) => {
            let dataFormatada = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            })

            return dataFormatada;
        }
    },
    {
        field: 'ParecerDocumentos',
        headerName: 'Parecer dos documentos',
        renderCell: (params) => {
            return verificaSituacaoDaAnalise(params, params.value);
        },
        flex: 1,
    },
    {
        field: 'DataParecerInstalacao', headerName: 'Data de parecer instalação', width: 200,
        renderCell: (params) => {
            let dataFormatada = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            })

            return dataFormatada;
        }
    },
    {
        field: 'ParecerInstalacao',
        headerName: 'Parecer instalação',
        renderCell: (params) => {
            return verificaSituacaoDaAnalise(params, params.value);
        },
        flex: 1,
    },
]

export { columnsAnaliseSolicitacaoCompartilhamentoAnalise };